import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';

import { MessageEvent, HiddenFooter, LoaderEvent, OpenFrameEvent } from './../../shared/message.event';
import { AppService } from './../../app.service';
import { AccountService } from './../account.service'
import { UtilityFunctions } from './../../shared/utility-functions';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { forEach } from '@angular/router/src/utils/collection';



@Component({
	selector: 'home-account',
	templateUrl: './home-account.component.html',
	styleUrls: ['./home-account.component.css'],
	providers: [MessageEvent, HiddenFooter, LoaderEvent, OpenFrameEvent, AccountService],
	exportAs: 'homeAccount',
	encapsulation: ViewEncapsulation.None
})
export class HomeAccount implements OnInit {
	private shouldSlide: boolean = false;
	private searchMember = '';
	private stringConstants = CONSTANT_MESSAGES;
	private facilityList = [];
	private selectedFacility = { name: 'All' };
	private vendor;
	private timezoneOffset;
	private startDate;
	private endDate;
	private isopenActivityDropdown = false;
	private popUpMessage = '';
	private paymentMethodList = ['Vendor', 'Mobile', 'All'];
	private isopenPaymentMethodDropdown = false;
	private selectedMethod = 'All';
	private exp = false;
	private utilityFunctions = new UtilityFunctions();
	private recordList = [];
	private message = '';
	private windowHeight = window.innerHeight;
	private topNav = 56;
	private midNav = 150;
	private footer = 35;
	private container = 20;
	private height: any;
	private divHeight = 30;
	private searchDisableFlag = false;
	@ViewChild('childModal') childModal: ModalDirective;
	@ViewChild('generateInvoice') generateInvoice: any;
	@ViewChild('pendingInvoice') pendingInvoice: any;

	private currentTab = 'Payment History';
	constructor(public appService: AppService, public router: Router, public accountService: AccountService, public messageEvent: MessageEvent, public hiddenFooter: HiddenFooter, public openFrameEvent: OpenFrameEvent, public loaderEvent: LoaderEvent) {
		this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
	}
	ngOnInit() {
		this.emitTypeBroadcast();
		this.registerTypeBroadcast();
		this.emitOpenFrameEvent();
		if (localStorage.getItem('vendor')) {
			this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
			this.timezoneOffset = this.vendor.timezoneOffset * -1;
		}
		this.getFacility();
		this.setDates();
		this.currentTab = 'Payment History';
		this.fetchPaymentHistory();
	}

	showTabEvent(event, generateInvoice) {
		this.searchMember = '';
		this.exp = false;
		this.currentTab = event.heading;
		if (this.currentTab == 'Generate Invoice') {
			this.searchDisableFlag = true;
			this.generateInvoice.resetInvoice();
		}
		this.searchMember = '';
		switch (this.currentTab) {
			case 'Payment History':

				this.fetchPaymentHistory();
				break;
			case 'Pending Invoice':
				this.pendingInvoice.fetchPendingInvoices();
				break;
		}

	}
	makeSearchDisable(event) {
		this.searchDisableFlag = event;
		this.exp = false;
		this.searchMember = '';
	}
	registerTypeBroadcast() {
		this.messageEvent.on()
			.subscribe(bool => {
				this.shouldSlide = bool;
			});
	}

	emitTypeBroadcast() {
		let isShow = {
			privacypolicy: true,
			support: false,
			footer: 'block'
		};
		this.hiddenFooter.fire(isShow);
	}
	emitOpenFrameEvent() {
		this.openFrameEvent.fire(false);
	}
	getFacility() {
		let that = this;
		that.facilityList = [];
		let facilityData = [];
		if (localStorage.getItem('vendor_facilityData')) {
			facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
		}
		facilityData.forEach(data => {
			data.data.forEach(facility => {
				that.facilityList.push(facility);

			});
		});
		if (that.facilityList.length > 1) {
			that.facilityList.push({ name: 'All' });
		}
	}

	facilityChange(item) {
		this.selectedFacility = item;
	}

	setDates() {
		let timeZoneDate = moment().utcOffset(this.timezoneOffset);
		let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = 23, minutes = 59;
		this.endDate = (new Date(year, month, date, hour, minutes));
		let eventstartDate = moment().subtract(6, 'days').utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
		year = eventstartDate.year(), month = eventstartDate.month(), date = eventstartDate.date(), hour = eventstartDate.hour(), minutes = eventstartDate.minutes();
		this.startDate = (new Date(year, month, date, hour, minutes));
	}

	fetchPaymentHistory(popUpObj?) {
		this.loaderEvent.fire(false);
		this.message = '';
		this.startDate.setHours(0, 0, 0);
		this.endDate.setHours(23, 59, 59);
		const eventStart = moment(this.startDate).utcOffset(this.timezoneOffset, true);
		const eventEnd = moment(this.endDate).utcOffset(this.timezoneOffset, true);
		if (eventStart.isBefore(eventEnd)) {
			let reqObj = {
				vendorId: this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
				filters: [],
				facilityIds: this.selectedFacility.name == 'All' ? this.getAllFacilitiesId() : [this.selectedFacility['_id']],
				paymentMethods: this.selectedMethod.toLocaleLowerCase(),
				startDate: eventStart,
				endDate: eventEnd,
				timezoneOffset: this.vendor.timezoneOffset * -1,
				startTime: '00:00',
				endTime: '24:00',
				paymentMode: 'paytm'
			}
			if (this.searchMember) {
				reqObj.filters.push({
					type: 'search',
					values: this.searchMember
				});
			} else {
				reqObj.filters = [];
			}
			let recordList = [];
			let recObj;
			let that = this;
			this.accountService.getPaymentHistory(reqObj).then((result: any) => {
				if (result.status == 'SUCCESS' && result.bookingData.length > 0) {
					this.recordList = result.bookingData.filter(function (rec: any) {
						rec.bookingStart = moment(rec.startTime).utcOffset(that.timezoneOffset).format('ll');
						rec.bookingEnd = moment(rec.endTime).utcOffset(that.timezoneOffset).format('ll');
						//start time
						let startHours = moment(rec.startTime).utcOffset(that.timezoneOffset).hour();
						let startMinutes = moment(rec.startTime).utcOffset(that.timezoneOffset).minutes();
						rec.startMinutes = startMinutes < 10 ? "0" + startMinutes : startMinutes;
						//hours + minutes
						rec.start = startHours < 10 ? "0" + startHours : startHours;
						rec.start = rec.start + ':' + rec.startMinutes;

						//end time
						let endHours = moment(rec.endTime).utcOffset(that.timezoneOffset).hour();
						let endMinutes = moment(rec.endTime).utcOffset(that.timezoneOffset).minutes();
						rec.endMinutes = endMinutes < 10 ? "0" + endMinutes : endMinutes;
						rec.end = moment(rec.endTime).utcOffset(that.timezoneOffset).hour();
						//hour + minutes
						rec.end = endHours < 10 ? "0" + endHours : endHours;
						rec.end = rec.end + ":" + rec.endMinutes;
						rec.paymentDoneDate = moment(rec.paymentDoneAt).utcOffset(that.timezoneOffset).format('ll');
						//start time
						let startHoursPayment = moment(rec.paymentDoneAt).utcOffset(that.timezoneOffset).hour();
						let startMinutesPayment = moment(rec.paymentDoneAt).utcOffset(that.timezoneOffset).minutes();
						rec.startMinutesPayment = startMinutesPayment < 10 ? "0" + startMinutesPayment : startMinutesPayment;
						//hours + minutes
						rec.startPayment = startHoursPayment < 10 ? "0" + startHoursPayment : startHoursPayment;
						rec.startPayment = rec.startPayment + ':' + rec.startMinutesPayment;

						return rec;
					});
					if (this.recordList.length == 0) {
						this.message = 'There is no payment history';
					}
				} else {

				}
				this.loaderEvent.fire(true);
			});

		} else {
			this.loaderEvent.fire(true);
			if (popUpObj) {
				this.popUpMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MESSAGE;
				popUpObj.showChildModal();
			}
		}
	}
	getAllFacilitiesId() {
		let that = this;
		let facilityIdsList = [];
		for (let data of this.facilityList) {
			if (data._id !== undefined) {
				facilityIdsList.push(data._id);
			}
		}
		return facilityIdsList;
	}

	expand() {
		if ((this.searchMember + '').trim()) {
			this.tabWiseSearch();
		} else {
			this.searchMember = '';
			if (this.exp) {
				this.tabWiseSearch();
			}
			this.exp = !this.exp;
		}
	}

	homeScreen() {
		this.utilityFunctions.homeScreen(this);
	}

	tabWiseSearch() {
		switch (this.currentTab) {
			case 'Payment History':
				this.fetchPaymentHistory();
				break;
			case 'Pending Invoice':
				this.pendingInvoice.fetchPendingInvoices();
				break;
			case 'Generate Invoice':
				this.generateInvoice.applySearch();
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/account/home-account/home-account.component.ts